module.exports = __webpack_public_path__ + "static/img/banner_02.39a6b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/banner_02.png
// module id = o9Db
// module chunks = 0